export default __webpack_public_path__ + "images/05922425bbbd4982c8b6f5239f698364-historic.jpg";